import { connect } from "react-redux";

import { getLoaderProps } from "domain/HttpRequests/selectors";
import GenericLoader from "components/Loaders/Generic";
import { GET, get } from "domain/Users/actions";

const mapStateToProps = (state, { gameId, playerId }) => {
    return {
        ...getLoaderProps(state, GET, { gameId, playerId }),
    };
};

const mergeProps = (stateProps, { dispatch }, ownProps) => {
    return {
        ...stateProps,
        ...ownProps,
        load: () =>
            dispatch(
                get({
                    gameId: ownProps.gameId,
                    playerId: ownProps.playerId,
                    code:null,
                    entity: ownProps.isRegular ? "regular_games" : "games"
                })
            ),
    };
};

export default connect(mapStateToProps, null, mergeProps)(GenericLoader);
